"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUGGESTION_ENTITY_TYPE = exports.FOCUS_TARGETS = exports.MEETINGS_PRO_TIP_ENTITY_KEY = exports.MEETINGS_LINK_ENTITY_TYPE = exports.MEETINGS_LINK_TYPES = exports.HIDE_MEETINGS_PLUGIN_PRO_TIP = exports.DOCUMENT_CONSTANTS = exports.VIDEO_CONSTANTS = exports.HIDDEN_FOLDER_PATH = exports.IMAGE_ATOMIC_TYPE = exports.IMAGE_BLOCK_TYPE = exports.LINK_ENTITY_TYPE = exports.replaceSelectionChangeTypes = exports.decoratorPropTypes = exports.INLINE_STYLES = exports.MISC_TYPES = exports.HEADER_TYPES = exports.LIST_TYPES = exports.MAX_LIST_DEPTH = exports.BLOCK_TYPES = exports.PLAIN_BLOCK = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var PLAIN_BLOCK = {
  label: 'Plain',
  style: 'unstyled',
  name: 'plain'
};
exports.PLAIN_BLOCK = PLAIN_BLOCK;
var BLOCK_TYPES = [PLAIN_BLOCK, {
  label: 'H1',
  style: 'header-one',
  name: 'h1',
  icon: 'h1'
}, {
  label: 'H2',
  style: 'header-two',
  name: 'h2',
  icon: 'h2'
}, {
  label: 'H3',
  style: 'header-three',
  name: 'h3',
  icon: 'h3'
}, {
  label: 'H4',
  style: 'header-four',
  name: 'h4',
  icon: 'h4'
}, {
  label: 'H5',
  style: 'header-five',
  name: 'h5',
  icon: 'h5'
}, // { label: 'H6', style: 'header-six', name: 'h6' },
{
  label: 'Blockquote',
  style: 'blockquote',
  icon: 'insertQuote' || 'quotes-left',
  name: 'blockquote'
}, {
  label: 'UL',
  style: 'unordered-list-item',
  icon: 'bulletList' || 'list-ul',
  name: 'ul'
}, {
  label: 'OL',
  style: 'ordered-list-item',
  icon: 'numberList' || 'list-ol',
  name: 'ol'
}, {
  label: 'Code Block',
  style: 'code-block',
  icon: 'code',
  name: 'codeblock'
}];
exports.BLOCK_TYPES = BLOCK_TYPES;
var MAX_LIST_DEPTH = 5;
exports.MAX_LIST_DEPTH = MAX_LIST_DEPTH;
var LIST_TYPES = BLOCK_TYPES.filter(function (_ref) {
  var style = _ref.style;
  return style.indexOf('list-item') > -1;
});
exports.LIST_TYPES = LIST_TYPES;
var HEADER_TYPES = BLOCK_TYPES.filter(function (_ref2) {
  var style = _ref2.style;
  return style.indexOf('header') > -1;
});
exports.HEADER_TYPES = HEADER_TYPES;
var MISC_TYPES = BLOCK_TYPES.filter(function (type) {
  return LIST_TYPES.indexOf(type) === -1 && HEADER_TYPES.indexOf(type) === -1 && type.style !== 'unstyled';
});
exports.MISC_TYPES = MISC_TYPES;
var INLINE_STYLES = [{
  label: 'Bold',
  style: 'BOLD',
  name: 'bold',
  icon: 'bold'
}, {
  label: 'Italic',
  style: 'ITALIC',
  name: 'italic',
  icon: 'italic'
}, {
  label: 'Underline',
  style: 'UNDERLINE',
  name: 'underline',
  icon: 'underline'
}];
exports.INLINE_STYLES = INLINE_STYLES;
var decoratorPropTypes = {
  entityKey: _propTypes.default.string,
  children: _propTypes.default.node
};
exports.decoratorPropTypes = decoratorPropTypes;
var replaceSelectionChangeTypes = (0, _keyMirror.default)({
  PUSH: null,
  SET: null
});
exports.replaceSelectionChangeTypes = replaceSelectionChangeTypes;
var LINK_ENTITY_TYPE = 'LINK';
exports.LINK_ENTITY_TYPE = LINK_ENTITY_TYPE;
var IMAGE_BLOCK_TYPE = 'atomic';
exports.IMAGE_BLOCK_TYPE = IMAGE_BLOCK_TYPE;
var IMAGE_ATOMIC_TYPE = 'IMAGE';
exports.IMAGE_ATOMIC_TYPE = IMAGE_ATOMIC_TYPE;
var HIDDEN_FOLDER_PATH = 'rich_text_hidden_files';
exports.HIDDEN_FOLDER_PATH = HIDDEN_FOLDER_PATH;
var VIDEO_CONSTANTS = {
  EMBED_SCRIPT_URL: 'https://app.vidyard.com/v1/embed.js',
  DRAFT_ATOMIC_TYPE_VIDEO: 'VIDEO',
  SALES_PROD_CLIENT_ID: 'sales.hubspot.com',
  SALES_QA_CLIENT_ID: 'sales.hubspotqa.com',
  SERVICE_HUB_PROD_CLIENT_ID: 'service.hubspot.com',
  SERVICE_HUB_QA_CLIENT_ID: 'service.hubspotqa.com',
  VIDEO_COMPONENT_PARENT_CLASS: 'video-component-parent',
  VIDEO_INTEGRATION_HAS_CREATED_VIDEO: 'video-integration-has-created-video',
  DEFAULT_VIDEO_WIDTH: 260,
  HAS_VIEWED_VIDEO_INTEGRATION_SHEPHERD: 'has-viewed-video-integration-shepherd'
};
exports.VIDEO_CONSTANTS = VIDEO_CONSTANTS;
var DOCUMENT_CONSTANTS = {
  DOCUMENT_LINK_PREVIEW_CLASS: 'document-link-plugin',
  DOCUMENT_LINK_PREVIEW_CONTAINER_CLASS: 'document-link-preview-container',
  DOCUMENT_LINK_PREVIEW_POPOVER_CLASS: 'document-link-preview-popover',
  DOCUMENT_ATOMIC_TYPE: 'DOCUMENT_LINK_PREVIEW',
  DOCUMENTS_LINK_ENTITY_TYPE: 'documentLink'
};
exports.DOCUMENT_CONSTANTS = DOCUMENT_CONSTANTS;
var HIDE_MEETINGS_PLUGIN_PRO_TIP = 'HideMeetingsPluginProTip';
exports.HIDE_MEETINGS_PLUGIN_PRO_TIP = HIDE_MEETINGS_PLUGIN_PRO_TIP;
var MEETINGS_LINK_TYPES = {
  OWNER: 'ownermeetingslink',
  SENDER: 'sendermeetingslink',
  CUSTOM: 'custommeetingslink'
};
exports.MEETINGS_LINK_TYPES = MEETINGS_LINK_TYPES;
var MEETINGS_LINK_ENTITY_TYPE = 'meetingsLink';
exports.MEETINGS_LINK_ENTITY_TYPE = MEETINGS_LINK_ENTITY_TYPE;
var MEETINGS_PRO_TIP_ENTITY_KEY = 'meetingsLinkProTip';
exports.MEETINGS_PRO_TIP_ENTITY_KEY = MEETINGS_PRO_TIP_ENTITY_KEY;
var FOCUS_TARGETS = {
  BODY: 'body',
  SUBJECT: 'subject'
};
exports.FOCUS_TARGETS = FOCUS_TARGETS;
var SUGGESTION_ENTITY_TYPE = 'suggestion';
exports.SUGGESTION_ENTITY_TYPE = SUGGESTION_ENTITY_TYPE;